import ApiGoogleUserDetails from 'types/api/GoogleUserDetails';

export default class GoogleUserDetails {
    fullName: string;
    firstName: string;
    lastName: string;
    email: string;

    constructor(data: ApiGoogleUserDetails) {
        this.fullName = data.name;
        this.firstName = data.given_name;
        this.lastName = data.family_name;
        this.email = data.email;
    }
}